import * as Sentry from '@sentry/browser';
import { FlashMessage } from '@components';

export interface LastItemJsonData {
  time_timestamp: string;
}

export const REFRESH_TIME = 60000;
const BUTTON_CLASS = '.lp-subscription__text-button';
const getFlashMessageContent = (linkClass: string, onlineReportId: string) => {
  return `
    <p>
      <strong>Na stránce přibyly nové příspěvky.</strong><br />
      <a href="javascript:void(0);"
         title="Zobrazit nové příspěvky"
         class="${linkClass}"
         onclick="window.location.href = window.location.origin + window.location.pathname + \'?rldd=\' + Date.now() + \'#online-' + ${onlineReportId};"
      >
        Zobrazit nové příspěvky
      </a>
    </p>
  `;
};
const initialTime = Math.floor(Date.now() / 1000);

const asyncTimeout = (timeoutTime: number) => {
  return new Promise((resolve) => {
    setTimeout(resolve, timeoutTime);
  });
};

// Hlavní funkce volaná ve smyčce a kontrolující API, zda neobsahuje novější příspěvek
const callLastOnlineReportItem = async (
  onlineReportPassed: HTMLElement,
  onlineReportApiId: string,
  onlineReportRefreshTime: number
) => {
  const apiUrl = `${window.location.origin}/online_reports/${onlineReportApiId}/last_item`;

  return fetch(apiUrl, {
    method: 'POST',
  })
    .then((response) => response.json())
    .then(async (data: LastItemJsonData) => {
      if (!data.time_timestamp)
        throw new Error('JSON poslední položky neobsahuje pole time_timestamp.');

      // Z API jsme dostali zprávu, že existuje novější příspěvek než máme na stránce
      if (data.time_timestamp && parseInt(data.time_timestamp) > initialTime) {
        // Kontrola, zda na stránce už flash message s refreshem neexistuje
        // Jinak pro příspěvky nastavené manuálně v budoucnosti můžeme dostat velké množství popupů
        const flashMessage = document.querySelector(`.flashMessage${onlineReportApiId}`);
        if (flashMessage) return;

        // Zobrazit flash message s refreshem a button tohoto přenosu
        await FlashMessage({
          msg: getFlashMessageContent(`flashMessage${onlineReportApiId}`, onlineReportApiId),
          autoHide: false,
          type: 'info',
        });

        const onlineReportButton: HTMLElement | null =
          onlineReportPassed.querySelector(BUTTON_CLASS);
        if (onlineReportButton) onlineReportButton.style.display = 'block';
      }
    })
    .then(async () => {
      await asyncTimeout(onlineReportRefreshTime);
      await callLastOnlineReportItem(
        onlineReportPassed,
        onlineReportApiId,
        onlineReportRefreshTime
      );
    })
    .catch((err) => {
      Sentry.captureException(err);
      if (err instanceof Error) {
        throw new Error(err.message);
      } else {
        throw new Error(
          'Nečekaný error v načítání online přenosu, nepodařilo se načíst API s poslední položkou online přenos: ' +
            apiUrl
        );
      }
    });
};

export const OnlineReportRefresh = async (
  onlineReports: NodeListOf<HTMLElement>,
  refreshTime: number = REFRESH_TIME
) => {
  for (const onlineReport of [...onlineReports.values()]) {
    const { onlineReportId } = onlineReport.dataset;
    if (!onlineReportId)
      throw new Error('Online přenos nemá nastavený atribut data-online-report-id.');

    await callLastOnlineReportItem(onlineReport, onlineReportId, refreshTime);
  }
};
export default OnlineReportRefresh;
